var okcities = 
    ["75001", "75002", "75003", "75004", "75005", "75006", "75007", "75008", "75009", "75010", "75011", "75012", "75013", "75014",
    "75015", "75016", "75017", "75018", "75019", "75020","92200", "92100", "92150", "92210", "92310", "92300", "92400", "92600",
    "92190", "92140", "92130", "92120", "92170", "92110"];

var deliveryCalendarRules = null;

function formatDeliveryDateKey(in_date) {
    var year = in_date.getFullYear();
    var month = in_date.getMonth() + 1;
    var day = in_date.getDate();

    month = month < 10 ? "0" + month : String(month);
    day = day < 10 ? "0" + day : String(day);

    return year + "-" + month + "-" + day;
}

function getParisNow() {
    if (window.Intl && Intl.DateTimeFormat) {
        try {
            var parts = new Intl.DateTimeFormat("en-CA", {
                timeZone: "Europe/Paris",
                year: "numeric",
                month: "2-digit",
                day: "2-digit",
                hour: "2-digit",
                hour12: false
            }).formatToParts(new Date());
            var values = {};

            for (var i = 0; i < parts.length; i++) {
                values[parts[i].type] = parts[i].value;
            }

            var hour = Number(values.hour);
            if (hour === 24) {
                hour = 0;
            }

            return new Date(
                Number(values.year),
                Number(values.month) - 1,
                Number(values.day),
                hour
            );
        } catch (error) {
            return new Date();
        }
    }

    return new Date();
}

function refreshDeliveryDatepicker() {
    if ($("#date").hasClass("hasDatepicker")) {
        $("#date").datepicker("refresh");
    }
}

function loadDeliveryCalendarRules() {
    $.getJSON("/apps/delivery-calendar")
        .done(function(data) {
            if (
                data &&
                Array.isArray(data.closedWeekdays) &&
                data.overrides
            ) {
                deliveryCalendarRules = data;
                refreshDeliveryDatepicker();
            }
        });
}

function my_check(in_date) {
    if (deliveryCalendarRules) {
        var dateKey = formatDeliveryDateKey(in_date);
        var overrideStatus = deliveryCalendarRules.overrides[dateKey];

        if (overrideStatus == "OPEN") {
            return [true, "av", "Disponible"];
        }

        if (overrideStatus == "CLOSED") {
            return [false, "notav", "Non Disponible"];
        }

        if (deliveryCalendarRules.closedWeekdays.indexOf(in_date.getDay()) !== -1) {
            return [false, "notav", "Non Disponible"];
        }

        return [true, "av", "Disponible"];
    }

    return window.legacy_my_check(in_date);
}

$(function(){

    document.getElementById("checkoutbtn").style.color = "black";
  		$( "#textfordate" ).hide();
		$( "#textfordate1" ).hide();
		$( ".deliveryOverall" ).hide();
		$( ".zipOverall" ).hide();
		$(".deliveryOverall").hide();
		$(".zipOverall").hide();
      
});

$(document).ready( function($) {
  
	document.getElementById("pick-delivery-time").options[3].disabled=true;
	document.getElementById("pick-delivery-time").options[0].disabled=true;
    loadDeliveryCalendarRules();
  
    /*Calendar for delivery*/
  
	$("#deliverymethod").click(function(){  
      $("#date").datepicker( {
        showAnim: "drop",
		minDate: 0,
		maxDate: '+6M',
		dateFormat:"DD d MM yy",
        firstDay: 1,	
        dayNames: ['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam'],
        dayNamesShort: ['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam'], // For formatting
        dayNamesMin: ['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam'], // Column headings for days starting at Sunday
        monthNames: ['Janvier','Février','Mars','Avril','Mai','Juin','Juillet','Août','Septembre','Octobre','Novembre','Décembre'],
        beforeShowDay: my_check
       });     
     });

    /*Calendar for pickup*/
	$("#pickupmethod").click(function(){
      $("#date").datepicker( {
          showAnim: "drop",
          minDate: 0,
          maxDate: '+6M',
          dateFormat:"DD d MM yy",
          firstDay: 1,	
          dayNames: ['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam'],
          dayNamesShort: ['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam'],
          dayNamesMin: ['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam'],
          monthNames: ['Janvier','Février','Mars','Avril','Mai','Juin','Juillet','Août','Septembre','Octobre','Novembre','Décembre'],
          beforeShowDay: my_check
        });
      });
                   

	/* Making Days Available & Unavailable For Delivery */    
window.legacy_my_check = function(in_date) {    

    /* Fermeture Juillet Août */
    if ((in_date.getFullYear() == 2025) && 
    ((in_date.getMonth() == 6 && in_date.getDate() >= 17) || 
     (in_date.getMonth() == 8 && in_date.getDate() <= 1))) {
    return [false, "notav", 'Non Disponible'];
} 
                   
  	/* St Valentin */
    /*if ((in_date.getMonth() == 1) && (in_date.getDate() == 14))  { 
		return [true, "av", 'Disponible']; 
	}*/

    if ((in_date.getMonth() == 1) && (in_date.getDate() == 14) && (in_date.getFullYear()== 2023))  { 
		return [false, "notav", 'Non Disponible']; 
	}
  
    if ((in_date.getMonth() == 1) && (in_date.getDate() == 13))  { 
		return [true, "av", 'Disponible']; 
	}
    
  
	/* Mother's day */
    
    if ((in_date.getMonth() == 5) && (in_date.getDate() == 4) && (in_date.getFullYear()== 2023))  { 
		return [true, "av", 'Disponible']; 
	}
    if ((in_date.getMonth() == 4) && (in_date.getDate() == 26) && (in_date.getFullYear()== 2024))  { 
		return [true, "av", 'Disponible']; 
	}
    if ((in_date.getMonth() == 4) && (in_date.getDate() == 25) && (in_date.getFullYear()== 2025))  { 
		return [true, "av", 'Disponible']; 
	}
    if ((in_date.getMonth() == 4) && (in_date.getDate() == 31) && (in_date.getFullYear()== 2026))  { 
		return [true, "av", 'Disponible']; 
	}
	if ((in_date.getMonth() == 4) && (in_date.getDate() == 30) && (in_date.getFullYear()== 2027))  { 
		return [true, "av", 'Disponible']; 
	}
	if ((in_date.getMonth() == 4) && (in_date.getDate() == 28) && (in_date.getFullYear()== 2028))  { 
		return [true, "av", 'Disponible']; 
	}
	if ((in_date.getMonth() == 4) && (in_date.getDate() == 27) && (in_date.getFullYear()== 2029))  { 
		return [true, "av", 'Disponible']; 
	}
	if ((in_date.getMonth() == 4) && (in_date.getDate() == 26) && (in_date.getFullYear()== 2030))  { 
		return [true, "av", 'Disponible']; 
	}
	if ((in_date.getMonth() == 4) && (in_date.getDate() == 25) && (in_date.getFullYear()== 2031))  { 
		return [true, "av", 'Disponible']; 
	}      
      
  	/* Father's day */
    
  	if ((in_date.getMonth() == 5) && (in_date.getDate() == 16) && (in_date.getFullYear()== 2024))  { 
		return [true, "av", 'Disponible']; 
	}
  	if ((in_date.getMonth() == 5) && (in_date.getDate() == 15) && (in_date.getFullYear()== 2025))  { 
		return [true, "av", 'Disponible']; 
	} 
    if ((in_date.getMonth() == 5) && (in_date.getDate() == 21) && (in_date.getFullYear()== 2026))  { 
		return [true, "av", 'Disponible']; 
	} 
    if ((in_date.getMonth() == 5) && (in_date.getDate() == 20) && (in_date.getFullYear()== 2027))  { 
		return [true, "av", 'Disponible']; 
	} 
    if ((in_date.getMonth() == 5) && (in_date.getDate() == 18) && (in_date.getFullYear()== 2028))  { 
		return [true, "av", 'Disponible']; 
	} 
    if ((in_date.getMonth() == 5) && (in_date.getDate() == 17) && (in_date.getFullYear()== 2029))  { 
		return [true, "av", 'Disponible']; 
	} 
    if ((in_date.getMonth() == 5) && (in_date.getDate() == 16) && (in_date.getFullYear()== 2030))  { 
		return [true, "av", 'Disponible']; 
	}
      
    /* 1er Mai */
    if ((in_date.getMonth() == 4) && (in_date.getDate() == 1))  { 
		return [true, "av", 'Disponible']; 
	}
      
	/* Closing days */
      
    if ((in_date.getMonth() == 0) && (in_date.getDate() >= 1) && (in_date.getDate() <= 4))  { 
		return [false, "notav", 'Non Disponible']; 
	}

      if ((in_date.getMonth() == 11) && (in_date.getDate() >= 25) && (in_date.getDate() <= 28) && (in_date.getFullYear()== 2022))  { 
		return [false, "notav", 'Non Disponible']; 
	}

    if ((in_date.getMonth() == 01) && (in_date.getDate() >= 28) && (in_date.getFullYear() == 2023))  { 
		return [false, "notav", 'Non Disponible']; 
	}

      if ((in_date.getMonth() == 02) && (in_date.getDate() == 1) && (in_date.getFullYear() == 2023))  { 
		return [false, "notav", 'Non Disponible']; 
	}
	
if (
  (
    (in_date.getMonth() == 11) &&
    (in_date.getDate() >= 25) &&
    (in_date.getFullYear() == 2025)
  ) ||
  (
    (in_date.getMonth() == 0) &&
    (in_date.getDate() <= 5) &&
    (in_date.getFullYear() == 2026)
  )
) {
  return [false, "notav", "Non Disponible"];
}    
  	
    /* Sunday and Monday disabled */
	if ((in_date.getDay() == 0) || (in_date.getDay() == 1)) { 
		return [false, "notav", 'Non Disponible']; 
	}

     
  
	else { 
		return [true, "av", "Disponible"]; 
	}
};

  /* Dynamically updates dropdown available time based on selected Day */ 

       
$("#date").on("change",function(){
		var selectedDate = $("#date").datepicker("getDate");
        if (!selectedDate) {
            return;
        }

        var now = getParisNow();   
		var hours = now.getHours();
        var isSunday = selectedDate.getDay() === 0;
           
           /* Grey out delivery times if selected day is today depending on current time */
           
		function sameDay(d1, d2) { 

		return d1.getFullYear() === d2.getFullYear() && d1.getMonth() === d2.getMonth() && d1.getDate() === d2.getDate();
        }	

			if (sameDay(selectedDate,now))
				{
	        document.getElementById("pick-delivery-time").options[1].disabled=true;
				}
	  
			if ((sameDay(selectedDate,now)) && (hours > 12))
				{
	        document.getElementById("pick-delivery-time").options[4].disabled=true;
				}
           
			if ((sameDay(selectedDate,now)) && (hours > 12))
				{
	        document.getElementById("pick-delivery-time").options[2].disabled=true;
	            }   
	  
			if ((sameDay(selectedDate,now)) && (hours > 1) && isSunday)
				{
	        document.getElementById("pick-delivery-time").options[2].disabled=true;
				}

	          /*Disable same day delivery for Valentine's Day*/
	        if ((sameDay(selectedDate,now)) && (selectedDate.getMonth() == 1) && (selectedDate.getDate() == 14)) 
				{
	        document.getElementById("pick-delivery-time").options[1].disabled=true;
	        document.getElementById("pick-delivery-time").options[2].disabled=true;
	        document.getElementById("pick-delivery-time").options[3].disabled=true;
	        document.getElementById("pick-delivery-time").options[4].disabled=true;
				}
      
           
          /* Set Delivery Time Back to normal and disable Sunday Afternoon */
           
        function notsameDay(e1, e2) {  
		return e1.getDate() !== e2.getDate() || e1.getMonth() !== e2.getMonth();	     
        	}
  
			if (notsameDay(selectedDate,now)) {
				document.getElementById("pick-delivery-time").options[1].disabled=false;
			}
			
	        if (notsameDay(selectedDate,now)) {
				document.getElementById("pick-delivery-time").options[2].disabled=false;
	        }
			
	  		/*if (notsameDay(selectedDate,now)) {
				document.getElementById("pick-delivery-time").options[3].disabled=false;
	        }*/
			
			if (notsameDay(selectedDate,now)) {
				document.getElementById("pick-delivery-time").options[4].disabled=false;
	        }
	       
	  		if ((notsameDay(selectedDate,now)) && isSunday) {
				document.getElementById("pick-delivery-time").options[1].disabled=true;
	      	}
	          
	        if ((notsameDay(selectedDate,now)) && isSunday) {
	        	document.getElementById("pick-delivery-time").options[2].disabled=true;
	      	}
      
      	
      	/* Disables Morning Pick Up after 8pm if selected date is tomorrow */
        function checktomorrow(f1, f2){
		return f1.getFullYear() === f2.getFullYear() && f1.getMonth() === f2.getMonth() && f1.getDate() === f2.getDate()+1;
      	}
	      	if ((checktomorrow(selectedDate,now)) && (hours > 20)) {
	        	document.getElementById("pick-delivery-time").options[1].disabled=true;
			}
      
 });
    

/* Disables Validate Order if no Delivery Date is selected */


$('#date').on('change', function (evt) {
  
    var valuedate = evt.target.value
    $('#pick-delivery-time').val('0');
    document.getElementById("pick-delivery-time").disabled = true;
    document.getElementById("checkoutbtn").disabled = true; 
    document.getElementById("checkoutbtn").style.color = "black";
  

  	if (valuedate.length > 0) {
  		evt.target.className = ''
		document.getElementById("pick-delivery-time").disabled = false; 
	}
  
    else  {  
		$('#pick-delivery-time').val('0');
		evt.target.className = ''
		document.getElementById("pick-delivery-time").disabled = true;
		document.getElementById("checkoutbtn").disabled = true; 
    	document.getElementById("checkoutbtn").style.color = "black";
	}
});


        /* Disables Validate Order if no Delivery Time is selected */

    
$('#pick-delivery-time').on('change', function (evt) {
  var valuePick = evt.target.value
  

  	if ((valuePick === ("Matin (10h - 13h)")) || (valuePick === ("Après-Midi (13h - 18h)")) || (valuePick === ("Soirée (18h - 20h)")) || (valuePick === ("Journée (10h - 20h)"))) {
  		evt.target.className = ''
		document.getElementById("checkoutbtn").disabled = false; 
    	document.getElementById("checkoutbtn").style.color = "white";
	}
  
    else  {  
		evt.target.className = ''
		document.getElementById("checkoutbtn").disabled = true; 
    	document.getElementById("checkoutbtn").style.color = "black";
      
	}
   });
  
});


function zipinvalid() {
        $('#pick-delivery-time').val('0');
        document.getElementById("date").disabled = true;
      	document.getElementById("pick-delivery-time").disabled = true;
      	document.getElementById("checkoutbtn").disabled = true; 
    	document.getElementById("checkoutbtn").style.color = "black";
}

$( document ).ready(function() {
  
  /* Checks if delivery is available for selected zipcode*/
  
$('#zipzip').on('input', function (evt) {
    var value = evt.target.value
 
	if ($.isNumeric(value)) {
    	evt.target.className = ''
  }
  
  
    if ((value.length === 5) && (okcities.includes(value))) {
    	evt.target.className = 'validdelivery'
		$('#zipzip').after('<span id="textforgood" class="ok-delivery"><br>Bonne nouvelle ! Nous pouvons vous livrer !</span>')
		document.getElementById("date").disabled = false;
		$( ".arrowZip" ).hide();
  }
  
  
	else if ((value.length === 5) && ($.isNumeric(value))) {
  		evt.target.className = 'invaliddelivery'
    	$('#zipzip').after('<span id = "textforbad" style="text-align:center" class="ko-delivery"><br>Nous ne livrons pas encore cette ville, mais vous pouvez venir retirer vos fleurs en boutique!</span>');
		$('#zipzip').before('<img class = "arrowZip" id="arrowZip" src="https://cdn.shopify.com/s/files/1/0259/8961/1583/files/arrowup.png?v=1602077874" />');
		$('#date').val('');
      	zipinvalid();
}

      /*Makes Pickup Method blink when delivery not available
        $('#pickupmethod').each(function() {
            var elem = $(this);
            elem.fadeOut(150)
                .fadeIn(150)
                .fadeOut(150)
                .fadeIn(150)
        });*/    		
	
    else if ((value.length < 5) && ($.isNumeric(value))) {
  		evt.target.className = ''
		$('#date').val('');
      	$('#pick-delivery-time').val('0');
      	zipinvalid();
		$( ".arrowZip" ).hide();
	}
  
  	else if (value.length === 0) {
		evt.target.className = ''
		$('#date').val('');
      	$('#pick-delivery-time').val('0');
      	zipinvalid();
	}
  
    else {
    	evt.target.className = 'invalid'
    	$('#zipzip').after('<span class="error-message"><br> Merci de ne renseigner que des chiffres</span>')
		$('#date').val('');
      	$('#pick-delivery-time').val('0');
      	zipinvalid();
		$( ".arrowZip" ).hide();
  	  }
	}               
)
});
